export default __webpack_public_path__ + "static/media/5.4f2b12d5.jpg";